import { useState } from "react";
import {
  Box,
  Text,
  Flex,
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  Stack,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useSession } from "next-auth/react";
import moment from "moment";
import toast from "react-hot-toast";
import { getAccount } from "utils/sessionHelper";
import { searchPeople } from "controllers/list";
import { getFormattedContacts } from "./utils";
import { textStyle } from "theme/names";

export function PrivateInteraction({ addPeople }) {
  const [dmInterval, setDmInterval] = useState<number>(7);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { data: session } = useSession() ?? {}

  const handleImport = async () => {
    setIsLoading(true);
    const since = new Date(
      // @ts-ignore
      moment().subtract(dmInterval, "day").startOf("day")
    ).getTime();

    const dataToSend: any = {
      idUser: getAccount(session)?.id,
      thWriteAccessToken: getAccount(session)?.thWriteAccessToken,
      thWriteSecretToken: getAccount(session)?.thWriteSecretToken,
      thApp: getAccount(session)?.thApp,
      from: "dm",
      since,
    };

    const data = await searchPeople(session, dataToSend);
    setIsLoading(false);

    if (data?.success === 0) {
      toast.error(data.error);
      return;
    }

    if (data.contacts.length === 0) {
      toast.success(`No DMs found from last ${dmInterval} days`);
    }

    const formattedList = getFormattedContacts(data.contacts);

    setDmInterval(7);
    addPeople(formattedList);
  };

  return (
    <Box>
      <Flex alignItems="start">
        <Stack spacing="0.5" mt="1">
          <Text textStyle={textStyle["body.medium.light"]} fontWeight="medium">
            Has already messaged me in DMs in the last
          </Text>
          <Text
            textStyle={textStyle["body.medium.light"]}
             as="i"
            fontSize="xs"
            mt="0"
          >
            Last 50 people only. Limit imposed by Twitter.
          </Text>
        </Stack>
        <Menu>
          <MenuButton
            as={Button}
            size="sm"
            variant="outline"
            rightIcon={<ChevronDownIcon />}
            ml="2"
          >
            {dmInterval} days
          </MenuButton>
          <MenuList maxH="215px" overflow="scroll">
            {[7, 14, 30].map((x) => (
              <MenuItem
                key={x}
                onClick={() => {
                  setDmInterval(x);
                }}
              >
                {x} days
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        <Button onClick={handleImport} size="sm" ml="4" isLoading={isLoading}>
          Import
        </Button>
      </Flex>
    </Box>
  );
}
